<template>
  <div>
    <Spin v-if="loading"></Spin>
    <div v-else-if="erpOrder">
      <div>
        <strong>{{ $t('order.order_number') }}: </strong>
        {{ erpOrder.BillNo }}
      </div>
      <div>
        <strong>{{ $t('order.total') }}: </strong>
        {{ intlCurrencyNumber(erpOrder.CurrID === 'RMB' ? 'CNY' : erpOrder.CurrID, erpOrder.Total, 5, 5) }}
      </div>
      <div>
        <strong>{{ $t('order.exchange_rate') }}: </strong>
        {{ parseFloat(erpOrder.ExchRate).toFixed(5) }}
      </div>
      <div>
        <strong>{{ $t('order.address') }}: </strong>
        {{ erpOrder.Address }}
      </div>
      <div>
        <strong>{{ $t('order.status') }}: </strong>
        {{ orderStatusLabel }}
      </div>
      <div>
        <strong>{{ $t('order.approval_status') }}: </strong>
        <span v-if="erpOrder.Permitter">
          <Icon type="ios-checkmark-circle" class="success" />{{ $t('order.approved') }}
        </span>
        <span v-else>{{ $t('order.pending_approval') }}</span>
      </div>
      <div style="white-space: pre-line">
        <strong>{{ $t('order.remark') }}: </strong>
        {{ erpOrder.Memo }}
      </div>
    </div>
    <div v-else>{{ $t('empty_data') }}</div>
  </div>
</template>

<script>
import { intlCurrencyNumber } from '@/libs/util'
import { mapActions } from 'vuex'
export default {
  name: "ErpOrderInfo",
  props: {
    orderId: {
      type: Number,
      requried: true
    }
  },
  data () {
    return {
      loading: false,
      erpOrder: null
    }
  },
  computed: {
    orderStatusLabel () {
      if (!this.erpOrder) return ''

      const orderBillState = {
        0: this.$t('order.open'),
        1: this.$t('order.closed'),
        2: this.$t('order.invalid')
      }

      return orderBillState[this.erpOrder.BillStatus]
    }
  },
  mounted () {
    this.loadErpOrder(this.orderId)
  },
  methods: {
    ...mapActions(['getErpOrder']),
    intlCurrencyNumber,
    loadErpOrder (orderId) {
      if (!orderId) return

      this.loading = true
      this.getErpOrder(orderId)
        .then((resp) => {
          this.erpOrder = resp.data
          this.$emit('on-erp-order-loaded', this.erpOrder)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    orderId (val) {
      this.loadErpOrder(val)
    }
  }
}
</script>
